import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {useAppSelector} from "../../shared/hooks/useAppSelector";
import {TeacherRole} from "../../shared/types/teacher";
import FullPageLoader from "../../shared/components/full-page-loader/FullPageLoader";

interface ProtectedRouteProps {
  roleRequired?: TeacherRole;
  redirectTo?: string;
  children?: React.ReactElement;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
                                                                roleRequired,
                                                                redirectTo = '/login',
                                                                children
                                                              }) => {
  const { authChecked, authenticated, currentTeacher } = useAppSelector(state => state.auth)
  if (!authChecked) {
    return <FullPageLoader/>
  }

  if (!authenticated) {
    return <Navigate to={redirectTo} replace />
  }

  if (roleRequired && currentTeacher?.role !== roleRequired) {
    return <Navigate to="/students" replace />
  }

  return children ? children : <Outlet />;
};